/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramHealthScore
 */
export interface ProgramHealthScore {
    /**
     * 
     * @type {Date}
     * @memberof ProgramHealthScore
     */
    computedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthScore
     */
    programHealthScore?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthScore
     */
    topLevelParentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramHealthScore
     */
    contributingParentCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramHealthScore
     */
    equalWeighting?: boolean;
}

/**
 * Check if a given object implements the ProgramHealthScore interface.
 */
export function instanceOfProgramHealthScore(value: object): value is ProgramHealthScore {
    return true;
}

export function ProgramHealthScoreFromJSON(json: any): ProgramHealthScore {
    return ProgramHealthScoreFromJSONTyped(json, false);
}

export function ProgramHealthScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramHealthScore {
    if (json == null) {
        return json;
    }
    return {
        
        'computedAt': json['computedAt'] == null ? undefined : (new Date(json['computedAt'])),
        'programHealthScore': json['programHealthScore'] == null ? undefined : json['programHealthScore'],
        'topLevelParentCount': json['topLevelParentCount'] == null ? undefined : json['topLevelParentCount'],
        'contributingParentCount': json['contributingParentCount'] == null ? undefined : json['contributingParentCount'],
        'equalWeighting': json['equalWeighting'] == null ? undefined : json['equalWeighting'],
    };
}

export function ProgramHealthScoreToJSON(json: any): ProgramHealthScore {
    return ProgramHealthScoreToJSONTyped(json, false);
}

export function ProgramHealthScoreToJSONTyped(value?: ProgramHealthScore | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'computedAt': value['computedAt'] == null ? undefined : ((value['computedAt']).toISOString()),
        'programHealthScore': value['programHealthScore'],
        'topLevelParentCount': value['topLevelParentCount'],
        'contributingParentCount': value['contributingParentCount'],
        'equalWeighting': value['equalWeighting'],
    };
}

